import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

const ClearFiltersButton = ({ clearFilters }) => {
    return (
        <span
            className="hoverable border-on-hover text-nowrap py-1 px-2 sc-glass rounded"
            onClick={clearFilters}>
            <FontAwesomeIcon icon={faTimes} />
            &nbsp;Clear Filters
        </span>
    );
};

export default ClearFiltersButton;
